// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"223":"dd3a87af71bae1bfd77d","245":"9226445fe8449732f420","453":"b32f0723c48e26a92ea9"}[chunkId] + ".js";
};